import { createWebHistory, createRouter } from 'vue-router'
import Store from '../stores'
import AuthConstants from '@/constants/auth.constants'
import InvoiceCreate from '@/views/Invoice/InvoiceCreate'
import OfferCreate from '@/views/Offer/OfferCreate'
import EnvelopeCreate from '@/views/Envelope/EnvelopeCreate'
import CheckoutView from '@/views/Payment/CheckoutView'
import StripeCheckoutView from '@/views/Payment/Stripe/CheckoutView'
import ConfirmationView from '@/views/Payment/ConfirmationView'
import LetterCreate from '@/views/Letter/LetterCreate'
import DocumentPreview from '@/views/Document/DocumentPreview'
import LoginView from '../views/Auth/LoginView.vue'
import DashboardLayout from '@/layouts/DashboardLayout'
import RegisterView from '../views/Auth/RegisterView.vue'
import PasswordReset from '../views/Auth/PasswordReset.vue'
import PasswordResetSession from '../views/Auth/PasswordResetSession.vue'
import VerifyRegister from '../components/Auth/VerifyRegister.vue'
import UserSubscription from '@/views/User/Sub.vue'
import UserDashboard from '@/views/User/DashboardView.vue'
import SubscriptionView from '@/views/Subscription/SubscriptionView.vue'
import SubscriptionCheckout from '@/views/Subscription/SubscriptionCheckoutV2'
import SubscriptionSuccess from '@/views/Subscription/SubscriptionSuccess'
import DonationSuccess from '@/views/Donation/DonationSuccess'
import PricingView from '@/views/Pricing/PricingView.vue'
import AllClients from '@/views/Clients/AllClients.vue'
import MyCompany from '@/views/Company/MyCompany.vue'
import AllDocuments from '@/views/Document/AllDocuments.vue'
import AllRecurringInvoices from '@/views/Invoice/AllRecurringInvoices.vue'
import CashflowView from '@/views/Cashflow/CashflowView.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardLayout,
    props: route => {
      let siteTitle = 'Rechnung'
      route.matched.forEach(matched => {
        if (matched.props && matched.props.default && matched.props.default.siteTitle) {
          siteTitle = matched.props.default.siteTitle
        }
      })
      return { siteTitle }
    },
    children: [
      {
        path: '',
        component: InvoiceCreate,
        name: 'dashboard',
        props: { siteTitle: 'Rechnung' }
      },
      {
        path: 'invoice',
        component: InvoiceCreate,
        name: 'dashboard.invoice',
        props: { siteTitle: 'Rechnung' }
      },
      {
        path: 'offer',
        component: OfferCreate,
        name: 'dashboard.offer',
        props: { siteTitle: 'Angebot' }
      },
      {
        path: 'letter',
        component: LetterCreate,
        props: { siteTitle: 'Brief' }
      },
      {
        path: '/pricing',
        component: PricingView,
        name: 'Pricing',
        props: { siteTitle: 'Preise' }
      },
      {
        path: '/all-clients',
        component: AllClients,
        props: { siteTitle: 'Alle Kunden' }
      },
      {
        path: '/all-documents',
        component: AllDocuments,
        props: { siteTitle: 'Alle Dokumente' }
      },
      {
        path: '/all-recurring-invoices',
        component: AllRecurringInvoices,
        props: { siteTitle: 'Alle Abonnements' }
      },
      {
        path: '/cashflow',
        component: CashflowView,
        props: { siteTitle: 'Umsatz' }
      },
      {
        path: '/my-company',
        component: MyCompany,
        props: { siteTitle: 'Meine Firma' }
      },
      {
        path: '/envelope/create/:documentUuid',
        name: 'EnvelopeCreate',
        component: EnvelopeCreate,
        props: true
      },
      {
        path: '/payment/checkout/:envelopeUuid',
        props: true,
        name: 'Checkout',
        component: StripeCheckoutView
      },
      {
        path: '/payment/confirmation',
        name: 'Confirmation',
        component: ConfirmationView,
        props: { siteTitle: 'Payment' }
      },
      {
        path: '/subscription/checkout',
        name: 'SubscriptionCheckout',
        component: SubscriptionCheckout,
        props: { siteTitle: 'Subscribe' }
      },
      {
        path: '/subscription/success',
        name: 'SubscriptionSuccess',
        component: SubscriptionSuccess,
        props: { siteTitle: 'Subscription' }
      },
      {
        path: '/donation/success',
        name: 'DonationSuccess',
        component: DonationSuccess,
        props: { siteTitle: 'Donation' }
      },
      {
        path: '/auth/login',
        name: 'Login',
        component: LoginView,
        props: { siteTitle: 'Login' }
      },
      {
        path: '/auth/register',
        name: 'Register',
        component: RegisterView,
        props: { siteTitle: 'Register' }
      },
      {
        path: '/auth/password-reset',
        name: 'PasswordReset',
        component: PasswordReset,
        props: { siteTitle: 'Password Reset' }
      },
      {
        path: '/user/dashboard',
        name: 'UserDashboard',
        component: UserDashboard,
        props: { siteTitle: 'My Dashboard' }
      },
      {
        path: '/user/subscription',
        name: 'UserSubscription',
        component: UserSubscription,
        props: { siteTitle: 'Subscription' }
      }
    ]
  },
  {
    path: '/document/:documentUuid/preview',
    name: 'DocumentPreview',
    component: DocumentPreview,
    props: true
  },
  {
    path: '/auth/password-reset/:sessionId',
    name: 'PasswordResetSession',
    component: PasswordResetSession,
    props: route => ({ sessionId: route.params.sessionId, siteTitle: 'PasswordResetSession' })
  },
  {
    path: '/auth/register/verify/:sessionId',
    name: 'VerifyRegister',
    component: VerifyRegister
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: SubscriptionView,
    props: { siteTitle: 'Subscription' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (Store.getters['auth/getLoginApiStatus'] === AuthConstants.LoginApiStatusSuccess) {
      next()
    } else {
      next('/auth/login')
    }
  } else {
    next()
  }
})

export default router
